import React, { useEffect, useState } from "react";

import { isAndroidPlayConsumptionOnly } from "../platform";

// Photos de l'accueil : l'élève qui étudie, puis l'enseignant qui génère ses
// épreuves. Changement toutes les 30 s, en fondu.
export const DELAI_DIAPORAMA_MS = 30000;

export const PHOTOS_ACCUEIL = [
  { src: "/static/accueil/eleve-accueil.jpg", position: "100% 35%", legende: "Une élève révise avec son manuel Quick Learning" },
  { src: "/static/accueil/generateur-accueil.jpg", position: "62% 50%", legende: "Un enseignant génère ses épreuves avec Quick Learning" },
];

// Applications Android Play et iPhone : uniquement la photo de l'élève, sans diaporama.
export const PHOTOS_PAR_PLATEFORME = isAndroidPlayConsumptionOnly ? [PHOTOS_ACCUEIL[0]] : PHOTOS_ACCUEIL;

export default function DiaporamaAccueil({ photos = PHOTOS_PAR_PLATEFORME, delai = DELAI_DIAPORAMA_MS }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (photos.length < 2) return undefined;
    const minuterie = setInterval(() => setIndex((i) => (i + 1) % photos.length), delai);
    return () => clearInterval(minuterie);
  }, [photos.length, delai, index]); // repart de 30 s après un choix manuel

  return (
    <div className="ql-accueil-photo">
      {photos.map((photo, i) => (
        <img key={photo.src} src={photo.src} alt={i === index ? photo.legende : ""} aria-hidden={i !== index}
          className={i === index ? "actif" : ""} style={{ objectPosition: photo.position }}
          loading={i === 0 ? "eager" : "lazy"} />
      ))}
      {photos.length > 1 && (
        <div className="ql-accueil-photo-points" role="group" aria-label="Choisir la photo">
          {photos.map((photo, i) => (
            <button key={photo.src} type="button" className={i === index ? "actif" : ""}
              aria-label={photo.legende} aria-pressed={i === index} onClick={() => setIndex(i)} />
          ))}
        </div>
      )}
    </div>
  );
}
